import { render, staticRenderFns } from "./FolderPath.vue?vue&type=template&id=16819866&"
import script from "./FolderPath.vue?vue&type=script&lang=ts&"
export * from "./FolderPath.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports